import { Book, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

type Props = {
  id: string;
  title: string;
  updateAt: Date;
};

export const NotificationItem = ({ id, title, updateAt }: Props) => {
  const timeAgo = date => {
    const now = Date.now();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 30) {
      return 'just now';
    }
    if (diffInSeconds < 60) {
      return '1 minute ago';
    }
    if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} minutes ago`;
    }
    if (diffInSeconds < 86_400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} hours ago`;
    }
    if (diffInSeconds < 2_592_000) {
      const days = Math.floor(diffInSeconds / 86_400);
      return `${days} days ago`;
    }
    if (diffInSeconds < 31_536_000) {
      const months = Math.floor(diffInSeconds / 2_592_000);
      return `${months} months ago`;
    }
    const years = Math.floor(diffInSeconds / 31_536_000);
    return `${years} years ago`;
  };

  return (
    <Link to={id}>
      <div className="mb-0 grid min-w-144 cursor-pointer grid-cols-[50px_auto_30px] rounded-md bg-white px-3 shadow-verail transition-shadow hover:shadow-verailHover">
        <div className="flex justify-center px-1">
          <Book size={20} />
        </div>
        <div className="flex flex-col items-start">
          <h2>{title}</h2>
          <p className="m-0 text-gray-500 text-sm">
            Last edited {timeAgo(updateAt)}
          </p>
        </div>
        <div className="flex items-center justify-start px-1">
          <ChevronRight />
        </div>
      </div>
    </Link>
  );
};
